export default "__VITE_ASSET__950ad6d9__"